import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { WithdrawalInstantBankTransferPage } from './withdrawal-instant-bank-transfer';

@NgModule({
  declarations: [
    WithdrawalInstantBankTransferPage,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
})
export class WithdrawalInstantBankTransferPageModule {}
